var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('el-dialog', {
    attrs: {
      "visible": _setup.visible,
      "show-close": false,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "custom-class": "package-locked-dialog",
      "width": "400px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function ($event) {
        _setup.visible = $event;
      }
    }
  }, [_c('section', {
    staticClass: "package-locked-dialog__content"
  }, [_c('button', {
    staticClass: "package-locked-dialog__close",
    attrs: {
      "type": "button",
      "aria-label": _vm.$t('common.Close')
    },
    on: {
      "click": _setup.closeDialog
    }
  }, [_c('i', {
    staticClass: "el-icon-close"
  })]), _c('img', {
    staticClass: "package-locked-dialog__illustration",
    attrs: {
      "src": require("@/assets/images/marketingTools/package-expire.png"),
      "alt": ""
    }
  }), _c('h2', [_vm._v(_vm._s(_vm.$t('dashboard.Package-Locked-Dialog-Title')))]), _c('p', {
    staticClass: "package-locked-dialog__description"
  }, [_vm._v(_vm._s(_vm.$t('dashboard.Package-Locked-Dialog-Content')))]), _c('div', {
    staticClass: "package-locked-dialog__actions"
  }, [_c('button', {
    staticClass: "package-locked-dialog__button package-locked-dialog__button--primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _setup.closeDialog();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('dashboard.Package-Locked-Dialog-Confirm')) + " ")])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };